import simpleParallax from 'simple-parallax-js';

export class Parallax {

    constructor()
    {
        let images = document.querySelectorAll('.parallax');
        new simpleParallax(images, {
            scale: 1.7,
            customContainer: images.parentNode,
            customWrapper: images.parentNode,
        });

    }

}


// WEBPACK FOOTER //
// ./js/util/simpleParallax.js